<div class="overflow-hidden">
  <span class="d-flex">
    <img [src]="logoUrl()" alt="Logo" class="h-50px app-sidebar-logo-default" />

    <img
      [src]="logoMinUrl()"
      alt="Logo"
      class="h-50px w-50px app-sidebar-logo-minimize position-relative"
      style="max-width: 100%"
    />
  </span>
</div>

<button
  class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
  (click)="onSidebarToggleClick()"
>
  <ui-keenicon
    name="double-left"
    class="fs-2 icon-sidebar"
    [class.rotate-180]="sidebarMinimizedState()"
  ></ui-keenicon>
</button>
